import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import SinglePin from 'containers/maps/SinglePin';
import SpeedPinList from 'containers/maps/SpeedPinList';
import $ from 'jquery';

class MapData extends React.Component {

    render() {

        console.info("map data rendered");

        const {translate, isIcnPlus, isDent, icn, icnPlus, isMilesPerHour, pdof, speedList, isSpeedListSearching} = this.props;

        var showSinglePinInMap = true;

        if(!isIcnPlus && !isDent)
        {
            /*
                pagina ICN
            */
            showSinglePinInMap = true;
        }
        else if(!speedList || speedList.length <= 0){
            /*
                è una ICNPlus o dent ma la lista di speed non è disponibile
            */
            showSinglePinInMap = true;
        }
        else{

            /*
                se tutte le velocità hanno valore 0 allora mostro solo il pin
            */

            var foundNotZero = false;
            $.each(speedList, function (index, item) {

                if(item.speed === 0)
                {
                    return;
                }

                foundNotZero = true;

            });

            if(foundNotZero)
            {
                showSinglePinInMap = false;
            }
            else{
                showSinglePinInMap = true;
            }


        }

        return (
            <div>
                {
                    showSinglePinInMap ?
                    <SinglePin icn={icn} icnPlus={icnPlus} translate={translate} isMilesPerHour={isMilesPerHour} pdof={pdof} />
                    :
                    <SpeedPinList speedList={speedList} isSpeedListSearching={isSpeedListSearching}
                        icn={icn} icnPlus={icnPlus} translate={translate} isMilesPerHour={isMilesPerHour} pdof={pdof} />
                }
            </div>
        );
    }
}

MapData.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        icn: state.icnSearch.item,
        isIcnLoading: state.icnSearch.isSearching,
        icnPlus: state.icnPlus.item,
        isIcnPlusSearching: state.icnPlus.isSearching,
        speedList: state.icnSpeed.list,
        isSpeedListSearching: state.icnSpeed.isSearching,
        accelerationList: state.icnAcceleration.list,
        isAccelerationListSearching: state.icnAcceleration.isSearching,
        isMilesPerHour: state.systemUnitsSearch.item ? state.systemUnitsSearch.item.isMilesPerHour : false,
        pdof: state.crashboxxPdof.binaries,
        isPdofSearching: state.crashboxxPdof.isSearching
    }
}
export default connect(mapStateToProps, null)(MapData);


// WEBPACK FOOTER //
// ./src/components/detailsPage/MapData.js